import React, { useContext, useEffect } from 'react';
import { BaseTable, Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { AppContext } from '../../../../../../Context/AppContext';
import { reconReportTotalVolume } from '../../../../../../api/services';
import { ChartContainer, StyleSpanText } from './ReconTotalValuesTable.style';
import { errorNotifyMessage, isApiResponseEmpty, replaceKeyTansoToCpm } from '../../../../../Utils/utils';
import { NCF_DASHBOARD_QTY_DECIMAL_PLACES } from '../../../../../../api/constants';
import { IReconDataPayload } from '../../../../../../Types/types';
import { notify } from '../../../../../../../CarbonDashboard/components/Toast/notify';

interface CellInfo {
  getValue: () => number | string;
}

export const columns = [
  {
    header: 'Data Type',
    accessorKey: 'dataType',
  },
  {
    header: 'CPM Data',
    accessorKey: 'inScopeVolume',
    cell: ({ getValue }: CellInfo) => {
      const value = getValue();
      if (typeof value === 'number') {
        return value.toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES);
      }
      return value;
    },
  },
  {
    header: 'ETRM Data',
    accessorKey: 'outOfScopeVolume',
    cell: ({ getValue }: CellInfo) => {
      const value = getValue();
      if (typeof value === 'number') {
        return value.toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES);
      }
      return value;
    },
  },
  {
    header: 'Delta (CPM - ETRM)',
    accessorKey: 'totalVolume',
    cell: (info: CellInfo) => getCellValue(info),
  },
];

const getCellValue = (info: CellInfo) => {
  const value = info.getValue();
  if (typeof value === 'number') {
    return <StyleSpanText value={value}>{value.toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES)}</StyleSpanText>;
  }
  return value;
};

interface PptReportingBarChartProps {
  setIsDataReconTotalVolumeDataEmpty: (isEmpty: boolean) => void;
}

const PptReportingBarChart: React.FC<PptReportingBarChartProps> = ({ setIsDataReconTotalVolumeDataEmpty }) => {
  const { state: reconState, dispatch: reconDispatch } = useContext(AppContext).reconReports;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const totalVolumeResponse = await reconReportTotalVolume({
          ...reconState.ReconfilteredValues,
          reportType: 'DELTA_DETAILS',
        });
        const convertedTotalVolumeRespData = replaceKeyTansoToCpm(totalVolumeResponse.data);
        reconDispatch({
          type: 'setReconReportDefaultTotalVolume',
          payload: convertedTotalVolumeRespData as IReconDataPayload,
        });
        setIsDataReconTotalVolumeDataEmpty(
                  isApiResponseEmpty(totalVolumeResponse.data));
      } catch (error) {
        notify('error', errorNotifyMessage(error));
      }
    };

    if (reconState.ReconfilteredValues.dataSource !== '') {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reconState.ReconfilteredValues]);

  // Add hardcoded rows for Total Volume and Total Count
  const hardcodedRows = [
    {
      dataType: 'Total Volume',
      inScopeVolume: reconState.reconReportDefaultTotalVolume.CPM.TOTAL_VOLUME,
      outOfScopeVolume: reconState.reconReportDefaultTotalVolume.ETRM.TOTAL_VOLUME,
      totalVolume: reconState.reconReportDefaultTotalVolume.DELTA.TOTAL_VOLUME,
    },
    {
      dataType: 'Total Count',
      inScopeVolume: reconState.reconReportDefaultTotalVolume.CPM.TOTAL_COUNT,
      outOfScopeVolume: reconState.reconReportDefaultTotalVolume.ETRM.TOTAL_COUNT,
      totalVolume: reconState.reconReportDefaultTotalVolume.DELTA.TOTAL_COUNT,
    },
  ];

  return (
    <ChartContainer data-testid='map-container'>
      <Flexbox style={{ width: '100%' }} gap='300px' justifyContent='space-between'>
        {/* <TableHeading>Pipeline Gas Volume Table</TableHeading> */}
      </Flexbox>
      {/* <Flexbox flexDirection="row" justifyContent="space-evenly" gap="20px"> */}
      <div>
        <BaseTable
          columns={columns}
          data={[...hardcodedRows]}
          size='large'
          data-testid='pipeline-gas-table'
          style={{ width: '100%' }}
        />
      </div>
      {/* </Flexbox> */}
    </ChartContainer>
  );
};

export default PptReportingBarChart;